<div class="palantir-badge" [ngClass]="['palantir-badge__' + theme]">
  <ng-content />
</div>
